import React from 'react';
import * as cls from './footer-ctas.module.css';
import { ROUTES_PATHS } from '../../../../constants';
import { Section } from '../../../../ui/components/section';
import { Typography } from '../../../../ui/components/typography';
import { Link } from 'react-router-dom';
import { Button } from '../../../../ui/components/button';

export const FooterCTAs = () => {
  return (
    <Section classNameRoot={cls.section}>
      <Typography as="h1" tag="h3">
        Launch a Pilot in Weeks
      </Typography>
      <Typography>
        Deploy clamp-on sensors with 5-minute installs, choose Wi-Fi or optional
        GSM, and integrate insights via APIs. Start with 50–500 homes, track
        engagement and savings within 30-60 days, and scale with OTA updates -
        no hardware swaps, minimal truck-roll.
      </Typography>
      <Link to={ROUTES_PATHS.REQUEST_A_DEMO}>
        <Button>Request Demo</Button>
      </Link>
    </Section>
  );
};
